module.exports = __webpack_public_path__ + "static/media/types-of-proxy-servers.5e7a07d3.png";